import React from "react"
import styled from 'styled-components'

import history from "../../routes/helper/history";
import CONSTANTS from "../../constants";


const CardMessage = styled.div`
    .card{
    background: linear-gradient(
    135deg,  
    rgba(255,255,255, 0.1) ,
    rgba(255,255,255, 0.1)  );
    backdrop-filter: blur(21px);
    -webkit-backdrop-filter: blur(21px);
    box-shadow: 0 8px  32px 0 rgba(0,0,0, 0.36);
    color: white;
   }
margin: 10px;
.card-text{
  
  margin: 2em 0;
}
.btn-codivas{
  padding: 5px 10px;
 
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.primary ? "palevioletred" : "#9b59b6")};
  color: #fff;
    font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  :hover{
    background:  #71bb73;
  }
}
`

const InfoMessage = ( {links} ) => {
  return (
   

    <CardMessage>
      <div class="card">
        <div class="card-header">
          Novo Portal Codivas
        </div>
        <div class="card-body">
         <h5 class="card-title"> Sua rede de mentorias chegou !</h5>
         <p class="card-text"> Após mais de 2 anos no mercado de mentorias, conteúdo e agência de software,hoje somos mais de 300 Codivas!!
        Por este motivo, criamos o portal para ajudar na comunicação entre nossas integrantes.
        </p>
         <a class=" btn-codivas " onClick={() => history.push(CONSTANTS.APP.CODIVAS) }> Conheça as Codivas !</a>
        </div>
      </div>
  </CardMessage>
 


   
  );
};

export default InfoMessage;
